import React from 'react';
import PropTypes from 'prop-types';

const contentContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'nowrap',
  width: '100%',
  padding: '0.5em'
};

const itemStyle = {
  color: '#d5d5d5',
  flexBasis: '15%',
  flexGrow: 0
};

const headerItemStyle = {
  textDecoration: 'underline',
  color: '#000'
};

const activeStyle = {
  color: '#000'
};

const redStyle = {
  color: 'red'
};

const greenStyle = {
  color: 'green'
};

const blueStyle = {
  color: '#0f257c'
}

const rowStyle = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  justifyContent: 'space-between',
  width: '100%'
};

const HeaderRow = ({ children }) => {
  return (
    <div style={{ ...rowStyle, ...headerItemStyle }}>{children}</div>
  );
};

const NonHeaderRow = ({ children }) => {
  return (
    <div style={{ ...rowStyle }}>{children}</div>
  );
};

const RowItem = ({ isActive, code, dispositionColor }) => {
  let colorStyle = {};
  let title = "";
  if (dispositionColor === "red") {
    colorStyle = redStyle;
    title = "CMS Accepted";
  }
  else if (dispositionColor === "green") {
    colorStyle = greenStyle;
    title = "CMS Accepted & MK Validated";
  }
  else if (dispositionColor === "blue") {
    colorStyle = blueStyle;
    title = "MK Validated";
  }
  else if (dispositionColor === "black")
    colorStyle = activeStyle;

  return (
    <div title={title} style={{ ...itemStyle, ...colorStyle }}>{code}</div>
  );
};

const Content = ({ children }) => {
  return (
    <div style={contentContainerStyle}>{children}</div>
  );
};

const createHeaderRow = headerRow => {
  const items = Object.keys(headerRow)
    .map(k => headerRow[k])
    .map((rowItem, i) => {
      const { isActive, code } = rowItem;
      const dispositionColor = "black";
      // TODO figure out a better key attribute
      return (<RowItem key={`rh_${i}`} code={code} isActive={isActive} dispositionColor={dispositionColor} />);
    });

  // TODO figure out a better key attribute
  return (
    <HeaderRow key={'header'}>
      {items}
    </HeaderRow>
  );
};

const createNonHeaderRow = (row, index) => {
  const items = Object.keys(row)
    .map(k => row[k])
    .map((rowItem, i) => {
      const { isActive, code, dispositionColor } = rowItem;

      // TODO figure out a better key attribute
      return (<RowItem key={`r_${i}`} code={code} isActive={isActive} dispositionColor={dispositionColor} />);
    });

  // TODO figure out a better key attribute
  return (
    <NonHeaderRow key={`non_header_${index}`}>
      {items}
    </NonHeaderRow>
  );
};

const pluckRow = (row, index) => {
  const isHeaderRow = someRow => someRow.col1.isHeader === true;

  return isHeaderRow(row) ? createHeaderRow(row) : createNonHeaderRow(row, index);
};

const PatientHistorySection = ({
  historyData
}) => {
  return (
    <div>
      <Content>
        {
          (historyData && historyData.length > 1)
            ? historyData.map(pluckRow)
            : <span>No History</span>
        }
      </Content>
    </div>
  );
};

PatientHistorySection.propTypes = {
  historyData: PropTypes.array.isRequired
};

export default PatientHistorySection;
